module.exports = __webpack_public_path__ + "static/img/2.2.a98e234.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/zh/2.2.png
// module id = pI44
// module chunks = 0